// @flow
import actionCreators from "@modules/profile/actionCreator";
import http from "@http";
import {
  GetMonitoringHistory,
  GetCurrentMonitoringStage,
} from "@modules/profile/constants/actions";
import { all, call, put, takeEvery } from "redux-saga/effects";
import type {
  CurrentMonitoringStage,
  MonitoringHistory,
} from "@modules/profile/reducer/my-absence-stage/types";

export function* onGetMyAbsenceMonitoringHistory(): Generator<
  *,
  void,
  { data: Array<MonitoringHistory> },
> {
  try {
    const response = yield call(http.get, "/api/v1/my-details/my-absence/monitoring-history");

    yield put(actionCreators.GetMonitoringHistorySuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetMonitoringHistoryError(e.response));
  }
}

export function* onGetMyCurrentAbsenceMonitoringStage(): Generator<
  *,
  void,
  { data: CurrentMonitoringStage },
> {
  try {
    const response = yield call(http.get, "/api/v1/my-details/my-absence/monitoring-stage/current");

    yield put(actionCreators.GetCurrentMonitoringStageSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetCurrentMonitoringStageError(e.response));
  }
}

export default function* MyAbsenceStageSaga(): Generator<*, void, void> {
  yield all([
    takeEvery(GetMonitoringHistory, onGetMyAbsenceMonitoringHistory),
    takeEvery(GetCurrentMonitoringStage, onGetMyCurrentAbsenceMonitoringStage),
  ]);
}
